import { useContext, useEffect, useMemo, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { convertApiHeaderToReactTableHeader } from "src/components/Common/UI/DndTable/UtilFunctions";
import { SydFilterContext } from "src/components/Common/UI/SydFilter/SydFilterContext";
import { useGetAllUserInspectorData } from "../api/getAllUserInspectorData";
import { useUserInspectorDownloadCsv } from "../api/getUserInspectorDownloadCsv";
import { format } from 'date-fns';

// All your logic is here
export const useUserInspectorDataViewLogic = () => {
  const { activeFilters } = useContext(SydFilterContext);
  const [modalEvent, setModalEvent] = useState<IEvent>({action: "", selectedValue: ""});
  const [selectedRowsOfTable, setSelectedRowsOfTable] = useState<IGetUserInspectorData["data"]>([]);
  const downloadAnchorRef = useRef<HTMLAnchorElement>(null);
  const userInspectorDownloadCsvMutation = useUserInspectorDownloadCsv({data: activeFilters as IUserInspectorSearchForm});
  let canDownloadCsv = false;
  const getAllUserInspectorDataQuery = useGetAllUserInspectorData({data: activeFilters as IUserInspectorSearchForm});
  const { t } = useTranslation();

  const loadingDone = [getAllUserInspectorDataQuery].every(({ isFetching }) => !isFetching);

  const isError = [getAllUserInspectorDataQuery].some(({ isError }) => isError);

  const dataTypes = [
    { id: 0, apiType: "Default", frontType: "", frontDisplayFormat: "" },
    { id: 1, apiType: "Integer", frontType: "number", frontDisplayFormat: "" },
    { id: 2, apiType: "Double", frontType: "number", frontDisplayFormat: "" },
    { id: 3, apiType: "Date", frontType: "date", frontDisplayFormat: "DD-MM-YYYY HH:mm:ss", sourceDisplayFormat: "YYYY-MM-DDTHH:mm:ss" },
    { id: 4, apiType: "String", frontType: "string", frontDisplayFormat: "" },
    { id: 5, apiType: "yyyyMMdd", frontType: "date", frontDisplayFormat: "YYYY-MM-DD", sourceDisplayFormat: "YYYYMMDD" },
    { id: 6, apiType: "Boolean", frontType: "boolean", frontDisplayFormat: "" },
    { id: 7, apiType: "IntegerTime", frontType: "date", frontDisplayFormat: "HH:mm:ss", sourceDisplayFormat: "seconds" },
    { id: 8, apiType: "yyyyMM", frontType: "date", frontDisplayFormat: "MMM YYYY", sourceDisplayFormat: "YYYYMM" }
  ];

  const data = getAllUserInspectorDataQuery.data ? getAllUserInspectorDataQuery.data.data : [];
  const totalRercords = getAllUserInspectorDataQuery.data ? getAllUserInspectorDataQuery.data.totalRercords : 0;

  if(getAllUserInspectorDataQuery.data){
    canDownloadCsv = getAllUserInspectorDataQuery.data?.data.length > 0;
  }

  const columnData = [
    {
      columnName: "id",
      columnDisplayName: "ID",
      visible: true,
      columnOrder: 1,
      isDraggable: false,
      columnDataType: "Number",
    },
    {
      columnName: "dateTime",
      columnDisplayName: "Ημερομηνία",
      visible: true,
      columnOrder: 2,
      isDraggable: false,
      columnDataType: "Date",
    },
    {
      columnName: "username",
      columnDisplayName: "Όνομα",
      visible: true,
      columnOrder: 3,
      isDraggable: false,
      columnDataType: "String",
    },
    {
      columnName: "event",
      columnDisplayName: "Κίνηση",
      visible: true,
      columnOrder: 4,
      isDraggable: false,
      columnDataType: "String",
    },
    {
      columnName: "eventLevel",
      columnDisplayName: "Επίπεδο Κίνησης",
      visible: true,
      columnOrder: 5,
      isDraggable: false,
      columnDataType: "String",
    },
    {
      columnName: "iPv4",
      columnDisplayName: "IPv4",
      visible: true,
      columnOrder: 6,
      isDraggable: false,
      columnDataType: "String",
    },
    {
      columnName: "iPv6",
      columnDisplayName: "IPv6",
      visible: true,
      columnOrder: 7,
      isDraggable: false,
      columnDataType: "String",
    },
    {
      columnName: "comments",
      columnDisplayName: "Σχόλια",
      visible: true,
      columnOrder: 7,
      isDraggable: false,
      columnDataType: "String",
    }
  ]

  const downloadFile = (blobString: string, reportName: string, fileExtension: string) => {
    if (downloadAnchorRef.current) {
      const recordingsBlob = new Blob([blobString], { type: 'application/octet-stream' }); // Set the type to 'application/octet-stream'
      const recordingsBlobURL = URL.createObjectURL(recordingsBlob);

      const currentDate: Date = new Date();
      const nowDateFormated: string = format(currentDate, 'yyyy-MM-dd_HH-mm-ss');
      const fileName:string = `${reportName}_${nowDateFormated}.${fileExtension}`;

      downloadAnchorRef.current.href = recordingsBlobURL;
      downloadAnchorRef.current.download = fileName;
      downloadAnchorRef.current.click();
    }
  }

  const DownloadCsv = async () => {
    userInspectorDownloadCsvMutation.mutateAsync({data: activeFilters as IUserInspectorSearchForm})
    .then((apiRecordingsCsvResponse) => {
      downloadFile(apiRecordingsCsvResponse, "UserInspector", "csv");
    }).catch((error) => {
      console.log(error)
    }) 
  }

  const actionEvent = async (event: IEvent) => {
    switch (event.action) {
      case "downloadCsv":
        await DownloadCsv();
        break;
      default:
        break;
    }
  }

  const columns = useMemo(() => {
    console.log("columnData",columnData)
    return convertApiHeaderToReactTableHeader(
      columnData ,
      dataTypes
    );
  }, []);

  useEffect(() => {
    setSelectedRowsOfTable([]);
    getAllUserInspectorDataQuery.refetch();
  }, [activeFilters]);

  return {
    data,
    columns,
    loadingDone,
    selectedRowsOfTable,
    setSelectedRowsOfTable,
    t,
    isError,
    downloadAnchorRef,
    canDownloadCsv,
    actionEvent,
    modalEvent,
    totalRercords
  };
};
